<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title m-b-0"><i class="ti-plug"></i> {{ $t('integrations') }} </h4>
                <ol class="breadcrumb">
                    <li><router-link :to="{ name: 'integrations.index' }">{{ $t('integrations') }}</router-link></li>
                    <li class="active">InForms</li>
                </ol>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <!-- Infos Integration -->
        <div class="card-box icon_integration">
            <div class="bar-widget m-b-15">
                <div class="table-box">
                    <div class="table-detail w_60">
                        <div class="iconbox">
                            <i class="ti-pencil-alt"></i>
                        </div>
                    </div>
                    <div class="table-detail">
                        <h5 class="m-t-0 m-b-5 d_inline_b">
                            <b>{{ $t('_integrations.name_in-forms') }}</b>
                        </h5>
                        <p class="m-b-5 text-muted">{{ $t('_integrations.description_in-forms') }}</p>
                    </div>
                </div>
            </div>
            <p>{{ $t('_integrations.in_forms.line_01') }}:</p>
            <ul>
                <li>{{ $t('_integrations.in_forms.line_02') }}</li>
                <li>{{ $t('_integrations.in_forms.line_03') }}</li>
                <li>{{ $t('_integrations.in_forms.line_04') }}</li>
                <li>{{ $t('_integrations.in_forms.line_05') }}</li>
            </ul>
            <div class="alert alert_default">
                <strong class="show m-b-5">{{ $t('attention') }}!</strong>
                <ul>
                    <li>{{ $t('_integrations.in_forms.line_06') }}.</li>
                    <li>{{ $t('_integrations.in_forms.line_07') }} <a href="/incoming" target="_blank" class="bold">{{ $t('_integrations.in_forms.line_08') }}</a> {{ $t('_integrations.in_forms.line_09') }}.</li>
                </ul>
            </div>
            <hr>
            <a href="http://blog.pumpmylead.com/integracao-com-formularios-web/" target="_blank" class="btn btn-purple"><span class="btn-label"><i class="fa fa-question-circle"></i></span>{{ $t('access_tutorial') }}</a>
            <router-link :to="{ name: 'integrations.informs.create' }" class="btn btn-default pull-right" v-if="this.$route.name === 'integrations.informs.index'"><span class="btn-label"><i class="fa fa-plus-circle"></i></span>{{ $t('integration') }}</router-link>
        </div>

        <!-- Form Integration -->
        <router-view @saved="saved"></router-view>

        <!-- List Integration -->
        <div class="bg_load_null min_h_98" v-pml-block="isLoading">
            <PmlItem v-for="item in list" :key="item.id" :item="item" @deleted="destroy"></PmlItem>
            <div v-show="!list.length">
                <p class="t_center m-t-30"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</p>
            </div>
        </div>

    </master-layout>
</template>

<script>
    import PmlItem from './Item.vue'
    import Notify from 'utils/helpers/notify'
    import TableFilters from 'utils/mixins/table-filters'
    import { trans } from 'utils/helpers/translation'
    import { getAllInForms } from 'services/integrations'
    import { removeById } from 'utils/helpers/arrays'
    import { isNil, find } from 'lodash'
    import { mapGetters } from 'vuex'

    export default {
        name: 'InForms',
        mixins: [ TableFilters ],
        components: { PmlItem },
        data () {
            return {
                records: [],
                isRefreshing: false,
                isLoading: false,
                listConfig: {
                    orderProp: 'created_at',
                    orderDir: 'asc',
                    columns: [ 'created_at' ]
                }
            }
        },
        metaInfo () {
            return {
                title: trans('integrations') + ' | InForms'
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            })
        },
        mounted () {
            if (!['premium_power_sales'].includes(this.tenant.stripePlan))
                this.$router.push({ name: 'error.404' })

            this.refresh()
        },
        methods: {
            destroy (id) {
                removeById(this.records, id)
            },
            saved (item) {
                if (!isNil(find(this.records, { id: item.id })))
                    removeById(this.records, item.id)

                this.records.push(item)
            },
            refresh () {
                this.isLoading = true

                getAllInForms()
                    .then(response => { this.records = response.data })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isLoading = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/in_forms/Main.vue